import { io } from "socket.io-client"
import { expectJwtSync } from "../../storage/jwt"

function initSocket() {
    const isProduction = process.env.REACT_APP_MODE === "production"
    const address = isProduction
        ? window.location.origin
        : "http://localhost:3002"
    return io(address, {
        path: isProduction ? "/api/socket" : "/socket",
        extraHeaders: { Authorization: expectJwtSync() },
        withCredentials: true
    })
}

export default initSocket
